<app-slide (draggingEvent)="receiveEvent($event)" [margin]="16" [elementWidth]="240"
    [elementQty]="orderedSystemByAmount.length">
    <ng-container>
        <app-payment-method-vcc [system]="item.system"
            *ngFor="let item of orderedSystemByAmount" [amount]="item.amount"
            (click)="notShowMatDialog ? '':selectMethod.emit(item.system)"></app-payment-method-vcc>
    </ng-container>
</app-slide>
